export const DD_RUM_AXEPTIO_KEY = "datadog-rum";
